import React, { useContext } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";

// userContext import
import { CurrentUserContext } from "context/UserContext";

const GuardedRoute = ({ component: Component, ...rest }) => {
  const [userContextData] = useContext(CurrentUserContext);
  const location = {
    pathname: "/login",
    state: { from: useLocation() },
  };
  return (
    <Route
      {...rest}
      render={(props) =>
        userContextData.isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect to={location} />
        )
      }
    />
  );
};

export default GuardedRoute;
